/**
 * Sedes y equipos de la institución.
 *
 * `variasSedes` lo decide el servidor y no la pantalla: es la misma regla que
 * usa el resto del sistema para saber si el concepto se menciona, y contarlo
 * aquí sería una segunda copia que acabaría discrepando.
 */

import { get, post } from '@/lib/api'

export interface Sede {
  id: string
  nombre: string
  direccion: string | null
  ciudad: string | null
  telefono: string | null
  zonaHoraria: string
  esPrincipal: boolean
  activa: boolean
}

export interface Equipo {
  id: string
  sedeId: string
  nombre: string
  sala: string | null
  /** Código DICOM: CT, MR, US... */
  modalidad: string
  aeTitle: string | null
  activo: boolean
}

export async function getSedes(): Promise<{ sedes: Sede[]; variasSedes: boolean }> {
  return get<{ sedes: Sede[]; variasSedes: boolean }>('/sedes')
}

export async function crearSede(datos: {
  nombre: string
  ciudad?: string | null
  direccion?: string | null
  telefono?: string | null
}): Promise<Sede> {
  const r = await post<{ sede: Sede }>('/sedes', datos)
  return r.sede
}

export async function actualizarSede(
  id: string,
  datos: Partial<Omit<Sede, 'id' | 'esPrincipal'>>
): Promise<Sede> {
  const r = await post<{ sede: Sede }>(`/sedes/${id}/update`, datos)
  return r.sede
}

export async function darDeBajaSede(id: string): Promise<void> {
  await post(`/sedes/${id}/delete`, {})
}

export async function getEquipos(
  sedeId?: string
): Promise<{ equipos: Equipo[]; modalidades: string[] }> {
  const query = sedeId ? `?sedeId=${sedeId}` : ''
  return get<{ equipos: Equipo[]; modalidades: string[] }>(`/equipos${query}`)
}

export async function crearEquipo(datos: {
  sedeId: string
  nombre: string
  modalidad: string
  sala?: string | null
  aeTitle?: string | null
}): Promise<Equipo> {
  const r = await post<{ equipo: Equipo }>('/equipos', datos)
  return r.equipo
}

export async function darDeBajaEquipo(id: string): Promise<void> {
  await post(`/equipos/${id}/delete`, {})
}
